import { SELECT_TOOL, ADD_TOOL, TARGET_SQUARE, DESELECT_TOOLS, ALTER_SQUARE } from '../actions/types';

const INITIAL = {
  available : {
    brush  : 0,
    mirror : 0,
    alarm  : 0,
    wand   : 0,
  },
  active : false
};

export default (state = INITIAL, action) => {

  switch (action.type) {
    case SELECT_TOOL : {
      let { field, value, tool } = action.payload;
      if (state.tool === tool) {
        return {...INITIAL, available : state.available}
      }
      else {

        return {field, value, tool, available : state.available, active : true};
      }

    }
    case ADD_TOOL : {

      let available = {...state.available};
      Object.keys(action.payload).forEach( tool => {
        if (available[tool] === undefined) {
          available[tool] = 0;
        }
        available[tool] += action.payload[tool];
      });

      return {
        ...state,
        available
      }
    }
    case ALTER_SQUARE : {
      if (state.value !== undefined && state.tool !== 'alarm') {
        return state;
      }
      else {
        let tool = state.tool;
        let available = {...state.available};
        available[tool]--;
        return {...INITIAL, available}
      }
    }
    case TARGET_SQUARE : {
      return { ...state, target_id : action.payload }
    }
    case DESELECT_TOOLS :
      return {...INITIAL, available : state.available}
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tools_reducer.js